import { ImagePath } from "../../../assets/ImagePath";
import { Input } from "../../../components/ui/input";
import { Button } from "../../../components/ui/button";
import { Label } from "../../../components/ui/label";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import LoadingModal from "../../../components/ui/Loader/LoadingModal";


const ChangePassword = () => {
    const navigate = useNavigate();
    const [errors, setErrors] = useState({ emailError: "", passwordError: "", nameError: "", phoneError: "", confirmPasswordError: "" });
    const [isFocused, setIsFocused] = useState({ email: false, password: false, name: false, phone: false, confirmPassword: false });
    const [highlightPass, setHighlightPass] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [userData, setUserData] = useState({ email: "", password: "", name: "", phone: "", confirmPassword: "", dialCode: "" });
    const [highlightConfirmPassword, setHighlightConfirmPassword] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const handleChange = (text, field, dialCode) => {
        if (field === "phone") {
            setUserData((prev) => ({ ...prev, phone: text, dialCode }));
        } else {
            setUserData((prev) => ({ ...prev, [field]: text.target.value }));
        }

        setErrors((prev) => ({ ...prev, [`${field}Error`]: "" }));
    };

    const handleSubmit = () => {

        let valid = true;
        let tempErrors = { emailError: "", passwordError: "", nameError: "", phoneError: "", confirmPasswordError: "" };

        // Name validation
        if (!userData.name.trim()) {
            tempErrors.nameError = "Name is required";
            valid = false;
        }

        // Email validation
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!userData.email.trim()) {
            tempErrors.emailError = "Email is required";
            valid = false;
        } else if (!emailPattern.test(userData.email)) {
            tempErrors.emailError = "Invalid email format";
            valid = false;
        }

        // Phone validation

        if (
            !userData.phone ||
            !userData.dialCode ||
            userData.phone.replace(userData.dialCode, '').trim() === ''
        ) {
            tempErrors.phoneError = "Phone number is required";
            valid = false;
        }

        // Password validation
        if (!userData.password) {
            tempErrors.passwordError = "Password is required";
            valid = false;
        } else if (userData.password.length < 6) {
            tempErrors.passwordError = "Password must be at least 6 characters";
            valid = false;
        }

        // Confirm Password validation
        if (!userData.confirmPassword) {
            tempErrors.confirmPasswordError = "Confirm Password is required";
            valid = false;
        } else if (userData.confirmPassword !== userData.password) {
            tempErrors.confirmPasswordError = "Passwords do not match";
            valid = false;
        }

        setErrors(tempErrors);
        if (valid) {
            setIsLoading(true);
            // Proceed with form submission (e.g., API call)
            console.log("Form submitted successfully", userData);
            setIsLoading(false);
            navigate("/verify", { state: { ...userData } });

        }
    }
    return (
        <div className="sm:col-span-6 col-span-12 lg:px-[60px] lg:py-[20px] px-[10px] py-[30px] h-full">
            <div className="flex flex-col h-full justify-between max-w-[491px] w-full !mx-auto">
            <img
                className="mx-auto 3xl:w-[210px] lg:w-[180px] w-[140px]"
                src={ImagePath.logoOnship}
                alt="Onship || Images(svg, jpg, png"
            />
            <div>
            <h1 className="lg:text-size-30 text-size-20 text-black font-semibold text-center lg:mb-[10px]">
                Change Your Password
            </h1>
            <p className="text-gray-300 text-size-14 font-regular text-center mb-12">
                Change your password for enhanced security.
            </p>
            <div className="bg-[#F8F8F8] rounded-20 lg:px-[45px] lg:py-[45px] p-[25px]">
                <div className="space-y-[20px]">
                    <div className="space-y-2 relative">
                        <Label
                            htmlFor="password"
                            labelError={errors.passwordError}
                            isFocused={isFocused.password}
                            highlightEmail={highlightPass}
                        >
                            Password
                        </Label>
                        <Input
                            type={showPassword ? "text" : "password"}
                            placeholder="Please enter your password"
                            inputError={errors.passwordError}
                            showPassword={showPassword}
                            setShowPassword={setShowPassword}
                            onChange={(t) => handleChange(t, "password")}
                            value={userData.password}
                            onBlur={() => setIsFocused({ password: false })}
                            onFocus={() => {
                                setIsFocused({ password: true })
                            }}
                        />
                        {errors.passwordError && (
                            <p className="text-red text-size-10 font-regular">
                                {errors.passwordError}.
                            </p>
                        )}
                    </div>
                    <div className="space-y-2 relative">
                        <Label
                            htmlFor="confirmPassword"
                            labelError={errors.confirmPasswordError}
                            isFocused={isFocused.confirmPassword}
                            highlightEmail={highlightConfirmPassword}
                        >
                            Confirm Password
                        </Label>
                        <Input
                            type={showConfirmPassword ? "text" : "password"}
                            placeholder="Please enter your confirm password"
                            inputError={errors.confirmPasswordError}
                            showPassword={showConfirmPassword}
                            setShowPassword={setShowConfirmPassword}
                            onChange={(t) => handleChange(t, "confirmPassword")}
                            value={userData.confirmPassword}
                            onBlur={() => setIsFocused({ confirmPassword: false })}
                            onFocus={() => {
                                setIsFocused({ confirmPassword: true })
                            }}
                        />
                        {errors.confirmPasswordError && (
                            <p className="text-red text-size-10 font-regular">
                                {errors.confirmPasswordError}.
                            </p>
                        )}
                    </div>
                    <Button variant="customBlue" onClick={handleSubmit}>
                        Reset Password
                    </Button>
                    <Button variant={"customGray"} onClick={handleSubmit}>
                        Cancel
                    </Button>
                </div>
            </div>
            </div>

            <img
                className="mx-auto w-full max-w-[260px] 3xl:mt-[80px] lg:w-[231px] mt-[30px] mb-6px"
                src={ImagePath.poweredText}
                alt="Onship || Images(svg, jpg, png"
            />
            </div>
        </div>
    );
};

export default ChangePassword;
